export const getContentCategoryMetadata = (
  contentCategory: WpContentCategoryName | WpContentCategorySlug | ServiceType
) => {
  switch (contentCategory) {
    case 'Content Category: Text':
    case 'text':
    case 'content-category-text':
      return {
        title: 'Content Writing',
        slug: '/samples/category/content-writing/'
      }
    case 'Content Category: Design':
    case 'design':
    case 'content-category-design':
      return {
        title: 'Design',
        slug: '/samples/category/design/'
      }
    case 'Content Category: Language & Translation':
    case 'vernacular':
    case 'language':
    case 'content-category-language':
      return {
        title: 'Language & Translation',
        slug: '/samples/category/language/'
      }
  }
}
